/* eslint-disable spaced-comment */
<template>
  <div class="logo">
    <img
      :src="$store.state.museumLogo ? getImage($store.state.museumLogo) : ''"
      alt=""
      style="width: 100%; height: 100%"
      v-if="$store.state.museumLogo"
    />
  </div>
</template>

<script>
import logo from "@/assets/images/chaoxing.png";

export default {
  name: "logo",
  props: ["museumCode"],
  data() {
    return {
      // status:this.props.status,//用户答题状态（correct、error、overtime、return）
      // rank: "", // 排名
      museumLogo: "",
      logo: logo,
    };
  },
  methods: {
    getMuseum() {
      if (this.$store.state.museumLogo) return
      if (this.$store.state.museumCode) {
        var code = this.$store.state.museumCode;
      } else {
        code = this.museumCode;
      }
      // console.log(code)
      if (code) {
        this.$http({
          url: this.$http.adornUrl("/api/admin/front/app/" + code),
          method: "get",
        }).then((res) => {
          // console.log(res.data.data.appLogo)
          res.data.data.appLogo
            ? (this.$store.state.museumLogo = res.data.data.appLogo)
            : console.log("无logo");
        });
      }
    },
    getImage(image) {
      return window.SITE_CONFIG.imageRootUrl + image;
    },
  },
  mounted() {
    this.$nextTick(() => {
      // console.log("1", this.museumCode)
      this.getMuseum();
    });
  },
  watch: {
    museumCode() {
      this.getMuseum();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.logo {
  margin: 0 auto 0.5rem;
  // position: absolute;
  width: 1.685rem;
  height: 0.463rem;
  // top: 5%;
  // left: 10%;
  img {
    height: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logo.vue